import { render, staticRenderFns } from "./ActiveLoans.vue?vue&type=template&id=eb8cc212&"
import script from "./ActiveLoans.vue?vue&type=script&lang=js&"
export * from "./ActiveLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports